export default {
    "login": {
        "title": "Log in into your account",
        "email": "Email",
        "placeholderEmail": "Your work email",
        "password": "Password",
        "placeholderPassword": "Your password",
        "login": "Log In",
        "forgot": "Have you forgotten your password?"
    },
    "reset": {
        "title": "Set new password",
        "text": "Set your new password complying with the security requirements shown below."
    },
    "forgot": {
        "title": "I forgot my password",
        "text": "Nothing happens! Write your email and we will send you the instructions to set a new password.",
        "actions": {
            "back": "Back",
            "send": "Send instructions"
        }
    }
};